ticketLineCount = 1;

window.claimVendorChange = function claimVendorChange() {
    el = document.getElementById("claim_vendor");
    selectedVendor = el.options[el.selectedIndex].value;
    orderLabel = document.getElementById("claim_order_number_label");
    orderEntry = document.getElementById("claim_order_number");
    if (selectedVendor === "Juicy Beats Shop") {
        orderLabel.className = "label";
        orderEntry.removeAttribute("disabled");
    } else {
        orderLabel.className = "has-text-white";
        orderEntry.setAttribute("disabled", "disabled");
    }
}

window.claimTicketTypeChange = function claimTicketTypeChange() {
    var festivalPhases = ["Phase 1", "Phase 2","Phase 3", "Phase 4"];
    var dayPassPhases = ["Phase 3", "Phase 4"];
    var festival21Phases = ["Phase 1"]

    ticketType = this.options[this.selectedIndex].value;
    lastPartOfId = this.id.substring(25);
    currentPos = lastPartOfId.substring(0, lastPartOfId.search("_"));
    phaseSelect = document.getElementById("claim_tickets_attributes_" + currentPos + "_phase");
    for (a in phaseSelect.options) {
        phaseSelect.options.remove(0);
    }
    if (phaseSelect.hasAttribute("disabled")) {
        phaseSelect.removeAttribute("disabled");
    }
    phaseSelect.classList.remove("has-text-white")
    if (ticketType == "Kombiticket Festival 2020") {
        festivalPhases.forEach(function (ticketPhase, index) {
            option = document.createElement("option")
            option.value = ticketPhase;
            option.text = ticketPhase;
            phaseSelect.appendChild(option)
        })
    } else if (["Freitagsticket 2020", "Samstagsticket 2020"].indexOf(ticketType) > -1) {
        dayPassPhases.forEach(function (ticketPhase, index) {
            option = document.createElement("option")
            option.value = ticketPhase;
            option.text = ticketPhase;
            phaseSelect.appendChild(option)
        })
    } else if (["Kombiticket Festival 2021", "Freitagsticket 2021", "Samstagsticket 2021"].indexOf(ticketType) > -1) {
        festival21Phases.forEach(function (ticketPhase, index) {
            option = document.createElement("option")
            option.value = ticketPhase;
            option.text = ticketPhase;
            phaseSelect.appendChild(option)
        })
    } else {
        option = document.createElement("option");
        option.value = "0";
        option.text = "Phase X";
        phaseSelect.appendChild(option);
        phaseSelect.classList.add("has-text-white");
        phaseSelect.setAttribute("disabled", "disabled")
    }
}

window.claimReceiptChange = function claimReceiptChange() {
    needsReceiptBox = document.getElementById("claim_needs_receipt");
    claimStreetInput = document.getElementById("claim_street");
    claimPostCodeInput = document.getElementById("claim_post_code");
    claimCityInput = document.getElementById("claim_city");
    if (needsReceiptBox.checked) {
        claimStreetInput.removeAttribute("disabled");
        claimPostCodeInput.removeAttribute("disabled");
        claimCityInput.removeAttribute("disabled");
    } else {
        claimStreetInput.setAttribute("disabled", "disabled");
        claimPostCodeInput.setAttribute("disabled", "disabled");
        claimCityInput.setAttribute("disabled", "disabled");
    }
}

window.buildControlDiv = function buildControlDiv(elementToEncapsulate) {
    controlDiv = document.createElement("div");
    controlDiv.className = "control";
    controlDiv.appendChild(elementToEncapsulate);
    return controlDiv;
}

window.deleteButton = function deleteButton(ticketLineCount) {
    buttonIcon = document.createElement("i")
    buttonIcon.className = "fa fa-minus-circle fa-2x";
    buttonIcon.setAttribute("onclick", `deleteClaimLine(${ticketLineCount})`);
    buttonSpan = document.createElement("span");
    buttonSpan.className = "icon has-text-danger is-large";
    buttonSpan.appendChild(buttonIcon);
    return buildControlDiv(buttonSpan);
}

window.buildClaimTicketNumberEntry = function buildClaimTicketNumberEntry(ticketLineCount) {
    input = document.createElement("input")
    input.className = "input"
    input.name = `claim[tickets_attributes][${ticketLineCount}][ticket_number]`;

    return buildControlDiv(input);
}

window.buildClaimTicketPhaseSelect = function buildClaimTicketPhaseSelect(ticketLineCount) {
    var ticketPhases = ["Phase 1", "Phase 2","Phase 3", "Phase 4"];

    var select = document.createElement("select");
    select.name = `claim[tickets_attributes][${ticketLineCount}][phase]`;
    select.id = `claim_tickets_attributes_${ticketLineCount}_phase`;
    ticketPhases.forEach(function (ticketPhase, index) {
        option = document.createElement("option")
        option.value = ticketPhase;
        option.text = ticketPhase;
        select.appendChild(option)
    })

    var selecDiv = document.createElement("div")
    selecDiv.className = "select"
    selecDiv.appendChild(select)
    return buildControlDiv(selecDiv);
}

window.buildClaimTicketTypeSelect = function buildClaimTicketTypeSelect(ticketLineCount) {
    var ticketTypes = ["Kombiticket Festival 2020", "Freitagsticket 2020", "Samstagsticket 2020",
        "Kombiticket Festival 2021", "Freitagsticket 2021", "Samstagsticket 2021",
        "VIP Kombi", "VIP Freitag", "VIP Samstag", "Campingticket", "Campingticket 2+1",
        "CamperVan Ticket", "Parkticket"];

    var select = document.createElement("select");
    select.name = `claim[tickets_attributes][${ticketLineCount}][ticket_type]`;
    select.id = `claim_tickets_attributes_${ticketLineCount}_ticket_type`;
    select.addEventListener("change", claimTicketTypeChange)
    ticketTypes.forEach(function (ticketType, index) {
        option = document.createElement("option")
        option.value = ticketType;
        option.text = ticketType;
        select.appendChild(option)
    })
    var selecDiv = document.createElement("div")
    selecDiv.className = "select";
    selecDiv.appendChild(select)
    return buildControlDiv(selecDiv);
}

window.buildClaimNewLine = function buildClaimNewLine(ticketLineCount) {
    labelDiv = document.createElement("div");
    labelDiv.className = "field-label is-normal";
    fieldDiv = document.createElement("div");
    fieldDiv.className = "field is-horizontal lineitem";
    fieldDiv.id = "ticket_claim_" + ticketLineCount.toString();
    fieldDiv.appendChild(labelDiv);
    fieldDiv.appendChild(buildClaimTicketTypeSelect(ticketLineCount))
    fieldDiv.appendChild(buildClaimTicketPhaseSelect(ticketLineCount))

    ticketLabel = document.createElement("div")
    ticketLabel.className = "field-label is-normal"
    ticketLabel.textContent = "Ticketnummer"
    fieldDiv.appendChild(ticketLabel)

    fieldDiv.appendChild(buildClaimTicketNumberEntry(ticketLineCount))
    fieldDiv.appendChild(deleteButton(ticketLineCount))
    return fieldDiv;
}

window.deleteClaimLine = function deleteClaimLine(lineId) {
    line = document.getElementById("ticket_claim_" + lineId.toString())
    line.classList.add("removed");
    setTimeout(function() {
        line.parentNode.removeChild(line);
    }, 500)
}

window.addSome = function addSome() {
    li = document.getElementById("lineItems")
    li.appendChild(buildClaimNewLine(ticketLineCount))
    ticketLineCount++;
}

